import { render, staticRenderFns } from "./DocumentBadgeSelector.vue?vue&type=template&id=db212a14&scoped=true&lang=pug"
import script from "./DocumentBadgeSelector.vue?vue&type=script&lang=js"
export * from "./DocumentBadgeSelector.vue?vue&type=script&lang=js"
import style0 from "./DocumentBadgeSelector.vue?vue&type=style&index=0&id=db212a14&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db212a14",
  null
  
)

export default component.exports